"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagWrapper = exports.NoticeMetaWrapper = exports.Group = exports.Div = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const NoticeMetaWrapper = exports.NoticeMetaWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "evjeu6p3"
} : {
  target: "evjeu6p3",
  label: "NoticeMetaWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1hi4meq",
  styles: "display:flex;position:relative;width:100%"
} : {
  name: "1hi4meq",
  styles: "display:flex;position:relative;width:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const Group = exports.Group = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "evjeu6p2"
} : {
  target: "evjeu6p2",
  label: "Group"
})(process.env.NODE_ENV === "production" ? {
  name: "7bcib0",
  styles: "display:grid;grid-template-columns:22px 1fr;grid-column-gap:0.5em;align-items:center;margin-right:1em"
} : {
  name: "7bcib0",
  styles: "display:grid;grid-template-columns:22px 1fr;grid-column-gap:0.5em;align-items:center;margin-right:1em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const Div = exports.Div = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "evjeu6p1"
} : {
  target: "evjeu6p1",
  label: "Div"
})();
const TagWrapper = exports.TagWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "evjeu6p0"
} : {
  target: "evjeu6p0",
  label: "TagWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "62ofw5",
  styles: "justify-self:flex-end;margin-left:auto"
} : {
  name: "62ofw5",
  styles: "justify-self:flex-end;margin-left:auto",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});